<template>
  <div>
    <div v-if="loadingPage == true && data.length === 0">
      <b-skeleton type="button" width="80px" class="skeleton-button"></b-skeleton>
      <div class="skeleton-wrapper">
        <div class="skeleton-ktp">
          <b-skeleton animation="wave" width="100px" class="skeleton-title"></b-skeleton>
          <b-skeleton type="input"></b-skeleton>
        </div>
        <div class="skeleton-selfie">
          <b-skeleton animation="wave" width="100px" class="skeleton-title"></b-skeleton>
          <b-skeleton type="input"></b-skeleton>
        </div>
        <div class="skeleton-npwp">
          <b-skeleton animation="wave" width="100px" class="skeleton-title"></b-skeleton>
          <b-skeleton type="input"></b-skeleton>
        </div>
      </div>
      <div class="skeleton-wrapper">
        <div class="skeleton-filter">
          <b-skeleton animation="wave" width="40px" class="skeleton-title"></b-skeleton>
          <b-skeleton type="input"></b-skeleton>
        </div>
        <div class="skeleton-date">
          <b-skeleton animation="wave" width="40px" class="skeleton-title"></b-skeleton>
          <b-skeleton type="input"></b-skeleton>
        </div>
        <div class="skeleton-partner">
          <b-skeleton animation="wave" width="60px" class="skeleton-title"></b-skeleton>
          <b-skeleton type="input"></b-skeleton>
        </div>
      </div>
      <b-skeleton-table :rows="10" :columns="11" :table-props="{ bordered: true }"></b-skeleton-table>
    </div>

    <div v-else>
      <div class="loading" v-if="isLoading == true">
        <div class="sk-three-bounce">
          <div class="sk-child sk-bounce1"></div>
          <div class="sk-child sk-bounce2"></div>
          <div class="sk-child sk-bounce3"></div>
        </div>
      </div>

      <b-row class="mb-3" v-if="$can('export')">
        <b-col sm>
          <button :disabled="isExport" class="btn btn-success my-2 mr-3" type="button" @click="exportTable">
            Export
          </button>
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col sm="4">
          <b-form-group
            class="mb-3"
            label="Search By"
            label-for="search"
            description="Partner users are only searchable by NIK"
          >
            <b-input-group>
              <b-input-group-prepend>
                <b-dropdown :text="typeFilter" v-model="typeFilter" variant="secondary">
                  <b-dropdown-item
                    v-for="(item, index) in typeData"
                    :key="index"
                    @click="onChangeDropdown(item.value, DROPDOWN_TYPE.SEARCH)"
                  >
                    {{ item.text }}
                  </b-dropdown-item>
                </b-dropdown>
              </b-input-group-prepend>
              <b-form-input id="search" type="search" v-model="filterText" placeholder="Name, Email, NIK, Phone ..."></b-form-input>
              <b-input-group-append>
                <b-button variant="secondary" @click="resetFilter" type="button">Reset</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col sm="4">
          <b-form-group class="mb-3" label="Date" label-for="daterange">
            <b-input-group>
              <b-input-group-prepend>
                <b-dropdown :text="dateFilterType" v-model="dateFilterType" variant="secondary">
                  <b-dropdown-item
                    v-for="(item, index) in dateFilterOptions"
                    :key="index"
                    @click="onChangeDropdown(item.value, DROPDOWN_TYPE.DATE)"
                  >
                    {{ item.text }}
                  </b-dropdown-item>
                </b-dropdown>
              </b-input-group-prepend>
              <range-picker
                id="daterange"
                :start="startDate"
                :end="endDate"
                :type="'clear'"
                :disable="false"
                :autoUpdate="false"
                :timePicker="false"
                @picker="doDateFilter"
              ></range-picker>
              <b-input-group-append>
                <b-button type="button" variant="secondary" @click="resetDateFilter">Reset</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col sm="4">
          <b-form-group class="mb-3" label="Partner" label-for="sp">
            <b-form-select id="sp" v-model="filterPartner" :options="partnerOptions"></b-form-select>
          </b-form-group>
        </b-col>

        <b-col sm="4">
          <b-form-group class="mb-3" label="KTP Status" label-for="sp">
            <b-form-select
              id="sp"
              v-model="filterKtp"
              :options="[
                { value: '', text: 'Choose KTP Status' },
                { value: '0', text: 'Not Verified' },
                { value: '1', text: 'Verified' },
                { value: '2', text: 'Rejected' },
                { value: '3', text: 'On Process' },
                { value: '4', text: 'Submitted' }
              ]"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col sm="4">
          <b-form-group class="mb-3" label="Selfie Status" label-for="sp">
            <b-form-select
              id="sp"
              v-model="filterSelfie"
              :options="[
                { value: '', text: 'Choose Selfie Status' },
                { value: '0', text: 'Not Verified' },
                { value: '1', text: 'Verified' },
                { value: '2', text: 'Rejected' },
                { value: '3', text: 'On Process' },
                { value: '4', text: 'Submitted' }
              ]"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col sm="4">
          <b-form-group class="mb-3" label="Verified By" label-for="vb">
            <b-form-select id="vb" v-model="filterVerifiedBy" :options="verifiedByOptions"></b-form-select>
          </b-form-group>
        </b-col>

        <b-col sm="4">
          <b-form-group class="mb-3" label="NPWP Status" label-for="sp">
            <b-form-select
              id="sp"
              v-model="filterNpwp"
              :options="[
                { value: '', text: 'Choose NPWP Status' },
                { value: '0', text: 'Not Verified' },
                { value: '1', text: 'Verified' },
                { value: '2', text: 'Rejected' },
                { value: '3', text: 'On Process' },
                { value: '4', text: 'Submitted' }
              ]"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-button :disabled="isButtonDisabled" :style="buttonStyle" class="mb-2" @click="doApplyFilter">
            Apply Filter
          </b-button>
          <p class="mb-3" :style="{ color: 'rgba(115, 129, 143, 1)' }">Click button 'Apply Filter' to apply the filter</p>
        </b-col>
      </b-row>

      <b-skeleton-table v-if="loadingTable == true" :rows="10" :columns="11" :table-props="{ bordered: true }"></b-skeleton-table>

      <vuetable
        v-else
        ref="vuetable"
        :api-mode="false"
        :fields="fields"
        :per-page="limit"
        :data-manager="dataManager"
        :no-data-template="isParams ? defaultTemplate : noDataTemplate"
      >
        <template slot="name-slot" slot-scope="prop">
          <span>{{ prop.rowData.name }}&nbsp;({{ prop.rowData.email }})</span>
        </template>
        <template slot="partner-slot" slot-scope="prop">
          <span>{{ prop.rowData.partner_name || "Treasury" }}</span>
        </template>
        <template slot="npwp_status" slot-scope="prop">
          <span :class="getStatusColor(prop.rowData.npwp_status)" v-if="prop.rowData.npwp_status === 1 || prop.rowData.npwp_status === 2">
            {{
              prop.rowData.npwp_action_by === "Not Verified"
                ? `${npwpValue(prop.rowData.npwp_status)}`
                : `${npwpValue(prop.rowData.npwp_status)} oleh ${prop.rowData.npwp_action_by}`
            }}
          </span>
          <span :class="getStatusColor(prop.rowData.npwp_status)" v-else>{{ `${npwpValue(prop.rowData.npwp_status)}` }}</span>
        </template>
        <template slot="action_by" slot-scope="prop">
          <span :class="{ 'text-gray': prop.rowData.action_by === 'Not Verified' }">{{ prop.rowData.action_by }}</span>
        </template>
        <template slot="actions-slot" slot-scope="prop">
          <div class="custom-actions" v-if="$can('kyc')">
            <button v-if="$can('update_verify_kyc')" type="button" class="btn btn-info m-1 text-white" @click="onAction('ktp-item', prop.rowData)">
              Detail
            </button>
            <button v-if="$can('update_verify_kyc')" type="button" class="btn btn-success m-1" @click="onAction('npwp-item', prop.rowData)">
              NPWP
            </button>
            <button
              v-if="$can('update_verify_kyc')"
              type="button"
              class="btn btn-warning m-1"
              :disabled="loadingLog && loadingLogId === prop.rowData.id"
              @click="onAction('log-response', prop.rowData)"
            >
              {{ loadingLog && loadingLogId === prop.rowData.id ? "Loading..." : "LOG" }}
            </button>
          </div>
        </template>
      </vuetable>

      <div v-show="isParams" class="vuetable-pagination ui basic segment grid">
        <div class="wrapper-pagination-custom">
          <div class="pagination-custom-info">
            <p>{{ this.paginationInfo }}</p>
          </div>
          <div class="pagination-custom-button">
            <button :disabled="currentPage === 1" @click="doMovePage('first')">
              <i v-if="currentPage === 1" class="fa fa-angle-double-left disabled"></i>
              <i v-else class="fa fa-angle-double-left"></i>
            </button>
            <button :disabled="currentPage === 1" @click="doMovePage('prev')">
              <i v-if="currentPage === 1" class="fa fa-angle-left disabled"></i>
              <i v-else class="fa fa-angle-left"></i>
            </button>
            <div>{{ this.currentPage }}</div>
            <button :disabled="data.length < 10" @click="doMovePage('next')">
              <i v-if="data.length < 10" class="fa fa-angle-right disabled"></i>
              <i v-else class="fa fa-angle-right"></i>
            </button>
          </div>
        </div>
      </div>

      <b-modal
        v-if="$can('kyc')"
        title="Edit Verifikasi NPWP"
        size="lg"
        v-model="npwpModal"
        @ok="npwpModal = false"
        hide-footer
      >
        <b-form @submit.prevent="npwpPost" novalidate>
          <b-row class="mb-4">
            <b-col>
              <h6>Organization / Partner : <strong>{{ this.from }}</strong></h6>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col>
              <h6>
                Nomor NPWP :
                <the-mask
                  mask="################"
                  v-model="npwpNumber"
                  type="text"
                  masked="true"
                  placeholder="Masukan Nomor NPWP"
                ></the-mask>
              </h6>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col>
              <h6 v-if="this.npwpUrl !== null">
                Foto NPWP :
                <a :href="this.npwpUrl" target="_blank" rel="noopener noreferrer">Open Image</a>
              </h6>
              <h6 v-else>Foto NPWP: <span style="color: red">Tidak ditemukan</span></h6>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col>
              <b-form-group label="NPWP Status :">
                <b-form-radio-group id="npwp--radio" v-model="npwpStatus" name="npwp--radio">
                  <b-form-radio :value="0">Not Verified</b-form-radio>
                  <b-form-radio :value="1">Verified</b-form-radio>
                  <b-form-radio :value="2">Rejected</b-form-radio>
                  <b-form-radio :value="3">On Process</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-group id="npwpReason" label="Alasan Reject NPWP" label-for="input-1" v-if="npwpStatus === 2">
            <b-form-input
              id="npwp"
              v-model="form.npwpReason"
              required
              autocomplete="on"
              placeholder="Masukan alasan Foto NPWP jika ditolak."
            ></b-form-input>
          </b-form-group>
          <p v-if="npwpStatus === 2" style="color: red">{{ form.npwpReason }}</p>
          <b-button type="submit" variant="primary">Submit</b-button>
        </b-form>
      </b-modal>

      <b-modal
        v-if="$can('kyc')"
        :title="logTitle"
        size="lg"
        v-model="logModal"
        @ok="logModal = false"
        centered
        hide-footer
      >
        <div class="wrapper-log-detail" v-if="log.detail_log && log.detail_log.length === 0">
          <p>Data Belum Tersedia!</p>
        </div>
        <div v-else>
          <b-card no-body v-for="(item, index) in log.detail_log" :key="item.title" class="mb-2">
            <b-card-header header-tag="header" class="p-1 bg-light" role="tab">
              <b-button block v-b-toggle="'accordion-' + index" class="text-left font-weight-bold" variant="light">{{ item.title }}</b-button>
            </b-card-header>
            <b-collapse :id="'accordion-' + index" class="p-2">
              <div class="d-flex align-items-start justify-content-between mb-3" v-for="items in item.logs" :key="items.id">
                <div class="d-flex align-items-start justify-content-center">
                  <div class="status-icon status-icon-success" v-if="items.status === 'success'"><i class="fa fa-check"></i></div>
                  <div class="status-icon status-icon-failed" v-else-if="items.status === 'failed'"><i class="fa fa-times"></i></div>
                  <div class="status-icon status-icon-pending" v-else-if="items.status === 'pending'"><i class="fa fa-clock-o"></i></div>
                  <div class="ml-3 d-flex flex-column" :style="{ width: '560px' }">
                    <p class="mb-1">{{ items.description }}</p>
                    <p class="text-success mb-1" v-if="items.status === 'success' && items.reason">{{ items.reason }}<br /><b>Verified</b></p>
                    <p class="text-danger mb-1" v-else-if="items.status === 'failed' && items.reason"><b>Rejected</b> <i>({{ items.reason }})</i></p>
                    <p class="text-warning mb-1" v-else-if="items.status === 'pending' && items.reason"><b>Pending</b> <i>({{ items.reason }})</i></p>
                    <p class="mb-1" v-else-if="items.reason">{{ items.reason }}</p>
                    <a v-if="items.attachment" target="_blank" :href="imageUrl(items.attachment)" class="text-info">Lihat Foto</a>
                  </div>
                </div>
                <p class="text-nowrap">{{ items.created_at }}</p>
              </div>
            </b-collapse>
          </b-card>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuetable from "vuetable-2/src/components/Vuetable";
import dotenv from "dotenv";
import { TheMask } from "vue-the-mask";
import _ from "lodash";
import moment from "moment";

dotenv.config();

Vue.use(Vuetable);

export default {
  name: "KycVerificationTab",
  props: {
    partnerOptions: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  components: {
    Vuetable,
    TheMask,
  },
  data() {
    return {
      DROPDOWN_TYPE: {
        SEARCH: "search",
        DATE: "date",
      },
      DATE_FILTER_TYPE: {
        REGISTER: "register_date",
        UPDATE: "latest_kyc_log",
      },
      page: 1,
      currentPage: 1,
      limit: 10,
      data: [],
      paginationInfo: "",
      filterVerifiedBy: "",
      filterKtp: "",
      filterPartner: "",
      filterNpwp: "",
      filterSelfie: "",
      startDate: "",
      endDate: "",
      form: {
        npwpReason: "",
      },
      errors: {
        code: "",
        message: "",
        status: "",
      },
      warning_message: "",
      loadingPage: false,
      loadingTable: false,
      isLoading: false,
      loadingLog: false,
      loadingLogId: null,
      npwpNumber: "",
      npwpStatus: 0,
      npwpUrl: "",
      from: "",
      verifiedByOptions: [
        { value: "", text: "Select Verifier" },
        { value: "", text: "Not Verified" },
        { value: "admin", text: "Admin" },
        { value: "privy-digital-id", text: "Privy Digital ID" },
        { value: "privy-submit-manual", text: "Privy Submit Manual" },
        { value: "id-wise", text: "ID Wise" },
      ],
      logModal: false,
      npwpModal: false,
      filterText: "",
      dateFilterType: "Register At",
      dateFilterOptions: [
        { value: "Register At", text: "Register At" },
        { value: "Update At", text: "Update At" },
      ],
      typeFilter: "Email",
      typeData: [
        { value: "Name", text: "Name" },
        { value: "Email", text: "Email" },
        { value: "NIK", text: "NIK" },
        { value: "Phone", text: "Phone" },
      ],
      sort: "updated|desc",
      moreParams: {},
      fields: [
        { name: "register_date", sortField: "register_date", title: "Register At" },
        { name: "name-slot", sortField: "name", title: "Name" },
        { name: "partner-slot", sortField: "partner_name", title: "Partner/Organization" },
        { name: "ktp", sortField: "ktp", title: "NIK", formatter: this.ktpValue },
        { name: "ktp_status", sortField: "ktp_status", title: "KTP Status", formatter: this.statusValue },
        { name: "selfie_status", sortField: "selfie_status", title: "Selfie Status", formatter: this.selfieValue },
        { name: "npwp_status", sortField: "npwp_status", title: "NPWP Status" },
        { name: "action_by", sortField: "action_by", title: "Verified by" },
        { name: "updated", sortField: "updated", title: "Updated At" },
        { name: "actions-slot", title: "Actions", titleClass: "center aligned", dataClass: "center aligned" },
      ],
      log: [],
      logTitle: "",
      noDataTemplate:
        '<div class="text-center d-flex align-items-center justify-content-center" style="height: 120px;"><p>Use filter to show your data.</p></div>',
      defaultTemplate:
        '<div class="text-center d-flex align-items-center justify-content-center flex-column" style="height: 120px;"><p><strong>No results found.</strong></p><p>Please adjust your filter or search keywords</p></div>',
    };
  },
  computed: {
    isButtonDisabled() {
      const filtersEmpty =
        this.startDate == "" &&
        this.endDate == "" &&
        this.filterText == "" &&
        this.filterVerifiedBy == "" &&
        this.filterPartner == "" &&
        this.filterNpwp == "" &&
        this.filterSelfie == "" &&
        this.filterKtp == "";

      const paramsEmpty = Object.entries(this.moreParams)
        .filter(([key, value]) => key !== "typeDate" && value)
        .length == 0;

      return filtersEmpty && paramsEmpty;
    },
    buttonStyle() {
      return {
        background: !this.isButtonDisabled ? "#7565F6" : "#c8ced3",
        color: !this.isButtonDisabled ? "#FFFFFF" : "inherit",
      };
    },
    isParams() {
      const params = Object.entries(this.moreParams).filter((entry) => entry[1]).length == 0;
      return !params;
    },
    isExport() {
      const hasStart = this.moreParams && String(this.moreParams.start_from || "").trim() !== "";
      const hasEnd = this.moreParams && String(this.moreParams.end_to || "").trim() !== "";
      const mandatory = this.startDate !== "" && this.endDate !== "";
      return !(mandatory && hasStart && hasEnd);
    },
  },
  watch: {
    data() {
      this.$refs.vuetable?.refresh();
    },
    logModal(value) {
      if (!value) this.log = [];
    },
    npwpModal(value) {
      if (!value) {
        this.from = "";
        this.npwpNumber = "";
        this.npwpUrl = "";
        this.npwpStatus = 0;
        this.form.npwpReason = "";
        this.params = "";
      }
    },
  },
  created() {
    this.$events.$on("apply-filter", this.onApplyFilter);
    this.$events.$on("date-set", this.onDateSet);
    this.$events.$on("filter-reset", this.onFilterReset);
    this.$events.$on("date-filter-reset", this.onDateFilterReset);
    this.$events.$on("movePage", this.onMovePage);

  },
  beforeDestroy() {
    this.$events.$off("apply-filter", this.onApplyFilter);
    this.$events.$off("date-set", this.onDateSet);
    this.$events.$off("filter-reset", this.onFilterReset);
    this.$events.$off("date-filter-reset", this.onDateFilterReset);
    this.$events.$off("movePage", this.onMovePage);
  },
  methods: {
    onFetch() {
      this.loadingTable = true;
      const newParams = Object.entries(this.moreParams)
        .filter((entry) => entry[1] !== null && entry[1] !== "undefined")
        .map(([key, value]) => `${key}=${value}`)
        .join("&");

      this.$http
        .get(`verify?page=${this.page}&per_page=10&&sort=${encodeURIComponent(this.sort)}${newParams ? `&${newParams}` : ""}`)
        .then((response) => {
          const startIndex = (response.data.current_page - 1) * this.limit;
          const endIndex = startIndex + this.limit;
          this.data = response.data.data;
          this.currentPage = response.data.current_page;
          this.paginationInfo = response.data.data.length > 0 ? `Displaying ${startIndex + 1} to ${endIndex}` : "No relevant data";
        })
        .catch((err) => {
          this.handleLoadError(err);
        })
        .finally(() => {
          this.loadingTable = false;
          this.loadingPage = false;
        });
    },
    handleLoadError(error) {
      this.errors.code = error.response.data.meta.code;
      this.errors.message = error.response.data.meta.message;
      this.errors.status = error.response.data.meta.code;
      if (this.errors.code == 401) {
        if (localStorage.getItem("access_token") != null) {
          localStorage.removeItem("access_token");
          this.$swal
            .fire("Your session expired!", "Your session has expired. Please login again to access this page!", "error")
            .then(() => {
              this.$router.push("/login");
            });
        }
      } else if (this.errors.code == 403) {
        this.$router.push("/403");
      } else if (this.errors.code == 500) {
        this.$router.push("/500");
      } else {
        this.$swal.fire("Error!", this.errors.message || "Something went wrong. Please try again later.", "error");
      }
    },
    doMovePage(value) {
      this.$events.$emit("movePage", value);
    },
    doApplyFilter() {
      this.$events.$emit("apply-filter");
    },
    resetFilter() {
      this.filterText = "";
      this.$events.$emit("filter-reset");
    },
    exportTable() {
      this.isLoading = true;
      const sDate = this.startDate || moment().format("YYYY-MM-DD");
      const eDate = this.endDate || moment().subtract(6, "days").format("YYYY-MM-DD");

      const params = Object.entries(this.moreParams)
        .filter(([key, value]) => {
          if (["start_from", "end_to"].includes(key)) return false;
          if (key === "typeFilter") return value && this.moreParams.filter;
          return value;
        })
        .map(([key, value]) => `${key}=${value}`)
        .join("&");

      this.$http
        .get(`ktp/${sDate}/${eDate}${params ? `?${params}` : ""}`)
        .then((result) => {
          this.isLoading = false;
          const exportPath = result.data.meta.data;
          window.location.href = exportPath;
        })
        .catch((error) => {
          if (error.response) {
            this.isLoading = false;
            this.errors.code = error.response.status;
            this.errors.status = error.response.data.meta.code;
          }
          this.handleLoadError(error);
        });
    },
    ktpValue(value) {
      return value != null ? value : '<font color="gray">Not Found</font>';
    },
    statusValue(value) {
      if (value == 0) return '<font class="text-gray">Not Verified</font>';
      if (value == 1) return '<font class="text-green">Verified</font>';
      if (value == 2) return '<font class="text-red">Rejected</font>';
      if (value == 3) return '<font class="text-warning">On Process</font>';
      if (value == 4) return "<font>Submitted</font>";
      return "<span> - </span>";
    },
    selfieValue(value) {
      if (value == 0) return '<font class="text-gray">Not Verified</font>';
      if (value == 1) return '<font class="text-green">Verified</font>';
      if (value == 2) return '<font class="text-red">Rejected</font>';
      if (value == 3) return '<font class="text-warning">On Process</font>';
      if (value == 4) return "<font>Submitted</font>";
      return "<span> - </span>";
    },
    npwpValue(value) {
      if (value == 0) return "Not Verified";
      if (value == 1) return "Verified";
      if (value == 2) return "Rejected";
      if (value == 3) return "On Process";
      if (value == 4) return "Submitted";
      return "-";
    },
    getStatusColor(value) {
      return {
        "text-gray": value === 0,
        "text-green": value === 1,
        "text-red": value === 2,
        "text-warning": value === 3,
      };
    },
    onAction(action, data) {
      if (action == "ktp-item") {
        const routeData = this.$router.resolve({ name: "Detail Verifikasi KYC", params: { id: btoa(data.id) } });
        window.open(routeData.href, "_blank");
      } else if (action === "npwp-item") {
        this.$http
          .put(`verify/` + data.id)
          .then((result) => {
            this.npwpModal = true;
            this.from = result.data.from;
            this.npwpNumber = result.data.verify.taxpayer_number || "";
            this.npwpUrl = result.data.verify.taxpayer_number_scan;
            this.npwpStatus = result.data.verify.npwp_status;
            this.form.npwpReason = result.data.verify.npwp_reason;
            this.params = result.data.verify.id;
          })
          .catch((error) => {
            this.handleLoadError(error);
          });
      } else if (action === "log-response") {
        if (this.loadingLog) return;
        this.loadingLog = true;
        this.loadingLogId = data.id;
        this.$http
          .get(`kyc-logs?user_id=` + data.id)
          .then((result) => {
            this.logModal = true;
            this.log = result.data.data;
            this.logTitle = `Log Detail (${this.log.name} - ${this.log.email})`;
          })
          .catch((error) => {
            this.handleLoadError(error);
          })
          .finally(() => {
            this.loadingLog = false;
            this.loadingLogId = null;
          });
      }
    },
    onMovePage(eventData) {
      if (eventData === "first") this.page = 1;
      else if (eventData === "prev") this.page--;
      else this.page++;
      this.onFetch();
    },
    npwpPost() {
      this.isLoading = true;
      this.$http
        .post(`verify-update/` + this.params, {
          type: "npwp",
          tax_id_number: this.npwpNumber,
          npwp_status: this.npwpStatus,
          npwp_reason: this.form.npwpReason,
        })
        .then(() => {
          this.isLoading = false;
          this.$swal.fire("Success!", "NPWP was successfully Updated.", "success").then(() => {
            location.reload();
          });
        })
        .catch((error) => {
          if (error.response) {
            this.isLoading = false;
            this.errors.status = error.response.data.meta.code;
            this.errors.message = error.response.data.meta.message;
            if (this.errors.status === 404) this.$swal.fire("Failed!", "NPWP failed to updated.", "error");
            if (this.errors.status === 400) this.$swal.fire("Failed!", this.errors.message, "error");
          }
        });
    },
    onApplyFilter() {
      this.page = 1;
      this.moreParams = {
        ...this.moreParams,
        verified_by: this.filterVerifiedBy,
        partner: this.filterPartner,
        taxpayer: this.filterNpwp,
        selfie_status: this.filterSelfie,
        id_number: this.filterKtp,
        start_from: this.startDate,
        end_to: this.endDate,
        typeFilter: this.filterText ? this.typeFilter : "",
        filter: this.filterText ? encodeURIComponent(this.filterText) : "",
      };
      this.onFetch();
    },
    doDateFilter(value) {
      this.$events.fire("date-set", value);
    },
    onDateSet(value) {
      this.moreParams = {
        ...this.moreParams,
        typeDate: this.moreParams.typeDate || "register_date",
      };
      this.startDate = value.startDate;
      this.endDate = value.endDate;
    },
    onFilterReset() {
      this.moreParams = Object.fromEntries(
        Object.entries(this.moreParams).map(([key, value]) => [key, key !== "filter" && key !== "typeFilter" ? value : ""])
      );
    },
    onDateFilterReset() {
      this.moreParams = Object.fromEntries(
        Object.entries(this.moreParams).map(([key, value]) => [key, key !== "start_from" && key !== "end_to" ? value : ""])
      );
    },
    resetDateFilter() {
      this.startDate = "";
      this.endDate = "";
      this.$events.$emit("date-filter-reset");
    },
    dataManager(sortOrder, pagination) {
      let local = this.data;
      if (sortOrder.length > 0) {
        const newSort = `${sortOrder[0].sortField}|${sortOrder[0].direction}`;
        if (this.sort !== newSort) {
          this.sort = newSort;
          this.onFetch();
        }
      }
      pagination = this.$refs.vuetable.makePagination(local.length, this.limit);
      let from = pagination.from - 1;
      let to = from + this.limit;
      return {
        pagination: pagination,
        data: local.length > 0 ? _.slice(local, from, to) : [],
      };
    },
    onChangeDropdown(value, type) {
      if (type === this.DROPDOWN_TYPE.SEARCH) {
        this.typeFilter = value;
      } else if (type === this.DROPDOWN_TYPE.DATE) {
        const dateType = value === "Register At" ? this.DATE_FILTER_TYPE.REGISTER : this.DATE_FILTER_TYPE.UPDATE;
        this.moreParams = { ...this.moreParams, typeDate: dateType };
        this.dateFilterType = value;
      }
    },
    imageUrl(url) {
      return url;
    },
  },
};
</script>

<style>
.text-gray { color: rgb(128, 128, 128); }
.text-info { color: #20a8d8; }
.text-red { color: #cb211f; }
.text-green { color: #35aa4b; }
.text-warning { color: #a78f27; }

.wrapper-log-detail {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.loading:before {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}

.wrapper-pagination-custom {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f9fafb;
}

.pagination-custom-button { display: flex; }

.pagination-custom-button button {
  width: 28px;
  height: 47px;
  padding: 13px 16px;
  font-size: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border: solid rgba(0, 0, 0, 0.3);
}

.pagination-custom-button button:first-child {
  padding: 13px 16px 13px 30px;
  border-radius: 4px 0 0 4px;
  border-width: 1px 0 1px 1px;
}

.pagination-custom-button button:nth-child(2),
.pagination-custom-button button:last-child {
  font-size: 1.3em;
  border-width: 1px;
}

.pagination-custom-button button:last-child {
  border-radius: 0 4px 4px 0;
}

.pagination-custom-button button i.disabled { opacity: 0.6; }

.pagination-custom-button div {
  width: 28px;
  height: 47px;
  font-size: 1em;
  font-weight: 500;
  background: #ffffff;
  border: solid rgba(0, 0, 0, 0.3);
  border-width: 1px 0 1px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.skeleton-button,
.skeleton-type,
.skeleton-wrapper {
  margin-bottom: 20px;
}

.skeleton-title {
  height: 18px;
  margin-bottom: 10px;
}

.skeleton-ktp,
.skeleton-selfie,
.skeleton-filter,
.skeleton-date {
  margin-right: 30px;
}

.skeleton-wrapper {
  display: grid;
  grid-template-columns: auto auto auto;
}

.status-icon {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
}

.status-icon-success { color: #35aa4b; background: #f2f5f9; }
.status-icon-failed { color: #cb211f; background: #fae9e9; }
.status-icon-pending { color: #d1b331; background: #faf7ea; }
</style>
<style src="spinkit/scss/spinkit.scss" lang="scss" />